import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  NavigationExtras,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from '../services/application/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(
    private _authService: AuthenticationService,
    private _router: Router
  ) {}

  public async canActivate(
    route: ActivatedRouteSnapshot
  ): Promise<boolean | UrlTree> {
    if (!this._authService.isLogged) {
      await this._authService.verifyIfIsLoggedIn();
    }

    if (this._authService.isLogged) {
      return true;
    } else {
      const fullPath = route.url.map((segment) => segment.path).join('/');

      const extras: NavigationExtras = {
        queryParams: {
          ...route.queryParams,
          routeUrlToRedirect:
            route.queryParams['routeUrlToRedirect'] || fullPath,
        },
      };
      this._router.navigate(['login'], extras);
      return false;
    }
  }
}
